import React, { Fragment, useState } from 'react'
import { Typeahead, Highlighter } from 'react-bootstrap-typeahead'
import './style.scss'

const Filter = ({ filter, text, label, option }) => {
  if (!filter) return null
  if (!option[filter]) return null

  return (
    <div key={filter}>
      <small>
        {label}: <Highlighter search={text}>{option[filter]}</Highlighter>
      </small>
    </div>
  )
}

const Inputs = ({ type, id, participant }) => {
  return (
    <Fragment>
      <input type='hidden' defaultValue={participant.id} name={id} />
      <input type='hidden' defaultValue={participant.type} name={type} />
    </Fragment>
  )
}

const MenuItem = (option, props, _index) => {
  console.log(option)
  return (
    <Fragment>
      <Highlighter search={props.text}>{option.name}</Highlighter>
      <span className='badge bg-light ms-2 text-muted'>{option.display_type || option.type}</span>
      {option.email && <Filter filter='email' text={props.text} label='Email' option={option} />}
    </Fragment>
  )
}

export default function PolymorphicPicker({ options, input_field_type, input_field_id, current_value = {}, errorMessage = '' }) {
  const [participant, setParticipant] = useState(current_value)

  return (
    <Fragment>
      {participant && <Inputs type={input_field_type} id={input_field_id} participant={participant} />}
      <div className='participant-typeahead-wrapper'>
        <Typeahead
          options={options}
          id={'participant-polymorphic-picker'}
          renderMenuItemChildren={MenuItem}
          filterBy={['name', 'email']}
          onChange={item => item[0] && setParticipant(item[0])}
          labelKey={'name'}
          inputProps={{ autoComplete: 'participant-email-input' }}
          defaultInputValue={(current_value && current_value.name) || ''}
          isInvalid={!!errorMessage}
        />
        {errorMessage && <div className='d-block invalid-feedback'>{errorMessage}</div>}
      </div>
    </Fragment>
  )
}
